import React from "react";
import { useParams } from "react-router";
import KilnForm from "./KilnForm";
import useKilnActions from "../hooks/useKilnActions";

import useFirebaseKiln from "../hooks/useFirebaseKiln";

const KilnEditPage = () => {
  const { editKiln } = useKilnActions();
  const { id } = useParams();

  const handleSubmit = (formValues: any) => {
    editKiln(id!, formValues);
  };

  const kiln = useFirebaseKiln(id!);
  if (!kiln) {
    return <div>Loading...</div>;
  }
  const new_kiln = {
    timed_controller: false,
    ambient_temperature: "16",
    controller: "dumb",
    controller_username: "",
    controller_password: "",
    controller_serial: "",
    ...kiln,
  };

  return (
    <div>
      <KilnForm onSubmit={handleSubmit} initialValues={new_kiln} />
    </div>
  );
};

export default KilnEditPage;
